import { Campaign, OverviewReport, Suggestion } from "./reducer";

export const TransformOverviewResponse = (
  response: OverviewResponse
): OverviewReport => {
  let campaigns: Campaign[] = [];

  response.campaigns.forEach((c) => {
    campaigns.push({
      id: c.id,
      clicks: c.clicks,
      appStoreUrl: c.appStoreUrl,
      platform: c.platform,
      conversion_rate:
        c.clicks > 0 ? Number((c.installs / c.clicks).toFixed(2)) : 0,
      countries: c.countries,
      installs: c.installs,
      name: c.name,
      appName: c.appName,
      appId: c.appId,
      mmp: c.mmp,
      iconUrl: c.iconUrl,
      playStoreUrl: c.playStoreUrl,
      spend: c.spend,
      status: c.status,
      isDirect: c.isDirect,
      bid: c.bid,
      biddingType: c.biddingType,
      biddingEvent: c.biddingEvent,
      clickUrl: c.clickUrl,
      genders: c.genders,
      maxAge: c.maxAge,
      dailyBudgetCap: c.dailyBudgetCap,
      maxApiLevel: c.maxApiLevel,
      minAge: c.minAge,
      minApiLevel: c.minApiLevel,
      roas_goals: c.roas_goals,
      creatives: c.creatives,
      suggestions: c.suggestions,
    });
  });

  campaigns.sort((a, b) => {
    return a.spend > b.spend ? -1 : 1;
  });

  return {
    campaigns: campaigns,
    from: response.from,
    graphRows: response.graphRows,
    totalInstalls: response.totalInstalls,
    totalSpend: response.totalSpend,
    until: response.until,
  };
};

export interface OverviewResponseGraphRow {
  date: Date;
  installs: number;
  spend: number;
}

export interface OverviewResponseCampaign {
  id: string;
  name: string;
  mmp: string | null;
  appName: string;
  appId: string;
  platform: "android" | "ios";
  iconUrl: string;
  playStoreUrl: string;
  appStoreUrl: string | null;
  countries: string[] | null;
  status: boolean;
  isDirect: boolean;
  installs: number;
  clicks: number;
  spend: number;

  genders: number[] | null;
  minAge: number | null;
  maxAge: number | null;
  minApiLevel: number | null;
  maxApiLevel: number | null;
  bid: number;
  biddingType: string;
  biddingEvent: string;
  dailyBudgetCap: number;
  clickUrl: string;
  roas_goals: { dx: string; url: number }[];
  creatives: { type: string; url: string }[] | null;
  suggestions: Suggestion[];
}

export interface OverviewResponse {
  from: Date;
  until: Date;
  totalInstalls: number;
  totalSpend: number;
  graphRows: OverviewResponseGraphRow[];
  campaigns: OverviewResponseCampaign[];
}
